import Skeleton , {SkeletonTheme} from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Loaderanimation = ({count}) => {

  console.log("count Loader",count);
  return (
     <SkeletonTheme
      baseColor="#e5e7eb"
      highlightColor="#f3f4f6"
      duration={1.2}
    >
    <div style={{ width: "100%" }}>
     <Skeleton count={count} 
     height={20}
     /> 
     </div>
     </SkeletonTheme>
  );
};

export default Loaderanimation;
